
import { defineComponent, onBeforeUpdate, onMounted, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'

import { mdiChevronLeft } from '@mdi/js'
import BaseSvgIcon from '@/components/BaseSvgIcon.vue'

export default defineComponent({
  components: { BaseSvgIcon },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const isShow = ref(false)
    const setShow = () => {
      isShow.value = !!(
        route.name !== 'Home'
        && route.name !== 'VideoList'
        && route.name !== 'SeminarList'
        && route.name !== 'NoticeList'
        && route.name !== 'Account'
        && route.name !== 'VideoDetails'
        && route.name !== 'AccountConfirmEmail'
      )
    }

    onBeforeUpdate(() => {
      setShow()
    })

    onMounted(() => {
      setShow()
    })

    return {
      mdiChevronLeft,
      router,
      isShow
    }
  },
})
